export const PAGE_TYPES = [
  'Homepage', 'Produktseite', 'Kategorieseite', 'Checkout',
  'Landingpage', 'Blog-Artikel', 'Kontaktseite', 'Suchergebnisse',
];

export const PAGE_TYPE_MAP = {
  'Homepage': 'homepage',
  'Produktseite': 'product',
  'Kategorieseite': 'category',
  'Checkout': 'checkout',
  'Landingpage': 'landingpage',
  'Blog-Artikel': 'blog',
  'Kontaktseite': 'contact',
  'Suchergebnisse': 'search',
};

export const CRO_CATEGORIES = [
  { key: 'headlines_ctas', name: 'Headlines & CTAs', color: '#0C9488', bg: '#E6F4F2' },
  { key: 'trust_social_proof', name: 'Trust & Social Proof', color: '#F59E0B', bg: '#FEF3C7' },
  { key: 'page_speed_ux', name: 'Page Speed & UX', color: '#10B981', bg: '#D1FAE5' },
  { key: 'form_optimization', name: 'Form Optimierung', color: '#EF4444', bg: '#FEE2E2' },
  { key: 'mobile_experience', name: 'Mobile Experience', color: '#3B82F6', bg: '#DBEAFE' },
  { key: 'content_relevance', name: 'Content Relevanz', color: '#8B5CF6', bg: '#EDE9FE' },
  { key: 'navigation', name: 'Navigation', color: '#0C9488', bg: '#E6F4F2' },
  { key: 'checkout_flow', name: 'Checkout Flow', color: '#EF4444', bg: '#FEE2E2' },
];
